// Curated option lists for assembly-instruction multi-selects. Users pick from
// these OR type a custom value (OptionTagPicker allows free entry), so the lists
// are a helpful default, not a hard constraint.

// ESD control measures (ANSI/ESD S20.20 / IEC 61340-5-1).
export const ESD_CONTROLS = [
  'Grounded wrist strap',
  'ESD work surface / mat',
  'ESD flooring + footwear',
  'EPA (ESD Protected Area)',
  'Air ionizer',
  'ESD smock / garment',
  'ESD-safe packaging / shielding bag',
  'ESD-safe tools',
  'Continuous wrist-strap monitor',
  'Humidity control',
  'Common-point ground / bonding',
];

// Personal protective equipment.
export const PPE_OPTIONS = [
  'ESD smock',
  'ESD wrist strap',
  'ESD heel / foot grounders',
  'Safety glasses',
  'Face shield',
  'Nitrile gloves',
  'Cut-resistant gloves',
  'Hearing protection',
  'Steel-toe shoes',
  'Lab coat',
];

// Operator competencies / qualifications.
export const COMPETENCY_OPTIONS = [
  'IPC-A-610 certified',
  'IPC J-STD-001 certified',
  'IPC/WHMA-A-620 certified',
  'ESD handling trained (ANSI/ESD S20.20)',
  'Hand-soldering certified',
  'Torque-tool trained',
  'Crimp / harness trained',
  'Optical / AOI inspection trained',
];
